import {Badge} from 'react-bootstrap'
import {Icons} from './Icons.jsx'
import {useSelector} from "react-redux";
import useCopyToClipboard from '../../hooks/useCopyToClipboard.js'

const CurrentUserInfo = () => {
    const user = useSelector((state) => state.user.user)
    const loggedUserId = user?.user_id || '-'
    const loggedUserEmail = user?.email || '-'
    const [_copiedText, copy] = useCopyToClipboard()

    return (
        <Badge
            bg={'light'}
            text={'dark'}
            className={'d-flex align-items-center gap-2 py-2 px-3 border-primary border'}
        >
            <span>ID: {loggedUserId}</span>
            <span
                title={'Skopiuj ID'}
                style={{cursor: 'pointer'}}
                onClick={() => copy(loggedUserId)}
            >
                <Icons.copy size={14}/>
            </span>
            <span className="border-start ps-2">Email: {loggedUserEmail}</span>
            <span
                title={'Skopiuj Email'}
                style={{cursor: 'pointer'}}
                onClick={() => copy(loggedUserEmail)}
            >
                <Icons.copy size={14}/>
            </span>
        </Badge>
    )
}

export default CurrentUserInfo
